import React from 'react'
import { Modal } from 'antd'

import history from '@/utils/history'
import { useGlobalContext } from '@/components/context'
import { formUrl } from '@/utils/url'
import { ModalProps } from '../common'
import NotificationList from './list'

type Props = ModalProps


const FieldNotificationModal = (props: Props) => {
	const globalContext = useGlobalContext()

	return (
		<Modal
			title="Notifications"
			open
			maskClosable
			onCancel={() => history.push(formUrl({recordId: props.recordId, formId: props.formId, ...globalContext}))}
			footer={null}
			width={600}
		>
			<p>
				When you set a notification you will be notified by email.
			</p>
				{globalContext.user.topLevelManager &&
					<p>
						If set to "Everyone" all users with access to the&nbsp;
						{globalContext.currentModule.recordWord.toLowerCase()} will be notified.
					</p>
				}
			<NotificationList {...props} />
		</Modal>
	)
}

export default FieldNotificationModal
